import { type EChartsExtensionInstallRegisters } from 'echarts/types/src/extension';
import GlobalModel from 'echarts/types/src/model/Global';
import ExtensionAPI from 'echarts/types/src/core/ExtensionAPI';
import { graphic } from 'echarts';
import { graphBeeswarmLayout } from './force';
import { staticLayout } from './static';
import { absoluteLayout } from './absolute';

export function install(registers: EChartsExtensionInstallRegisters) {
  registers.registerLayout(graphBeeswarmLayout);
  registers.registerLayout(staticLayout);
  registers.registerLayout(absoluteLayout);
}
